import React, { FC, ReactNode } from "react";

const ListItemStyle: FC<{
  featureType: "Point" | "Polygon" | "LineString" | "Custom" | string;
  color: { fill: string; stroke: string };
  children?: ReactNode;
}> = (props) => {
  const { featureType, color, children } = props;
  switch (featureType) {
    case "Point":
      return (
        <svg height="30" width="30">
          <circle
            cx="15"
            cy="15"
            r="12"
            style={{
              fill: color.fill,
              stroke: color.stroke,
              strokeWidth: "2px",
            }}
          />
          {children}
        </svg>
      );
    case "Polygon":
      return (
        <svg height="30" width="30">
          <polygon
            points="3,15 10,27 27,20 15,3 3,15"
            style={{
              fill: color.fill,
              stroke: color.stroke,
              strokeWidth: "2px",
            }}
          />
          {children}
        </svg>
      );
    case "LineString":
      return (
        <svg height="30" width="30">
          <polygon
            points="3,26 26,3 30,6 6,30 3,26"
            style={{
              fill: color.fill,
              stroke: color.stroke,
              strokeWidth: "2px",
            }}
          />
          {children}
        </svg>
      );
    case "Custom":
    default:
      return null;
  }
};
export default ListItemStyle;

// TODO: exterminate
export function getListItemStyleAsHTML(featureType: "Point" | "Polygon" | "LineString", color: { fill: string; stroke: string }) {
  switch (featureType) {
    case "Point":
      return `<svg height="30" width="30" style="position:relative; top:5px">
          <circle
            cx="15"
            cy="15"
            r="12"
            style="fill: ${color.fill}; stroke: ${color.stroke}; stroke-width: 2px"
          />
        </svg>`;
    case "Polygon":
      return `<svg height="30" width="30" style="position:relative; top:5px">
          <polygon
            points="3,15 10,27 27,20 15,3 3,15"
            style="fill: ${color.fill}; stroke: ${color.stroke}; stroke-width: 2px"
          />
        </svg>`;
    case "LineString":
      return `<svg height="30" width="30" style="position:relative; top:5px">
          <polygon
            points="3,26 26,3 30,6 6,30 3,26"
            style="fill: ${color.fill}; stroke: ${color.stroke}; stroke-width: 2px"
          />
        </svg>`;
  }
}
